/* eslint-disable no-unused-vars */
import {
  unauthorizedAdminRoutePath,
  unauthorizedRoutePath
} from '../../../../routes/routePaths'
import history from '../../../../store/history'
import LocalStorageService from '../../../LocalStorageService'
import { addActualPathRedirectSlugToPath } from '../../../../helpers/addActualPathRedirectSlugToPath'
import { isAlreadyInUnauthorizedRoute } from '../../../auth'

const authTokenInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      if (error.response?.status === 401) {
        console.log('Sem autorização. Redirecionando...')

        LocalStorageService.remove('token')
        LocalStorageService.remove('user')
        // LocalStorageService.remove('company')

        // Redirect to login page
        if (!isAlreadyInUnauthorizedRoute()) {
          const actualPath = history.location.pathname
          const isAdmin = actualPath.includes('admin')

          if (isAdmin) {
            history.push(
              addActualPathRedirectSlugToPath(unauthorizedAdminRoutePath)
            )
          } else {
            history.push(addActualPathRedirectSlugToPath(unauthorizedRoutePath))
          }
        }
      }

      return Promise.reject(error)
    }
  )
}

export default authTokenInterceptor
